export const appReducers = [
  { key: 'app', loadReducer: () => import('./app') },
  { key: 'conversation', loadReducer: () => import('./conversation') },
  { key: 'firebase', loadReducer: () => import('./firebase') },
  { key: 'booking', loadReducer: () => import('./booking') },
  { key: 'banner', loadReducer: () => import('./banner') },
  { key: 'warning', loadReducer: () => import('./warning') },
  {
    key: 'schedule',
    loadReducer: () => import('routes/Dashboard/SetupSchedule/SetupScheduleState'),
  },
  {
    key: 'classDetail',
    loadReducer: () => import('routes/Dashboard/ClassDetail/ClassDetailState'),
  },
  { key: 'request', loadReducer: () => import('routes/Dashboard/Request/RequestState') },
]
